import ReferralApi from './ReferralApi';

export default ReferralApi;
